import { FC, useMemo } from "react";
import { Box, Center, HStack, Progress, Stack, Text } from "@chakra-ui/react";

import { useGetLimitQuery } from "../../../../../api/limit";
import { formatPrice, formatPriceWithoutZeros, isStringWithNumber } from "../../../../../utils";

export const SbpTransferPageLimit: FC = () => {
  const { data } = useGetLimitQuery();

  const availableAmount = isStringWithNumber(data?.cashBalance)
    ? formatPriceWithoutZeros(Number(data?.cashBalance))
    : formatPrice(0, 0);
  const totalAmount = isStringWithNumber(data?.amount) ? formatPrice(Number(data?.amount), 0) : "";
  const totalAmountText = totalAmount ? `из лимита Denum ${totalAmount}` : "";

  const percentageLeft = useMemo(() => {
    const total = isStringWithNumber(data?.amount) ? Number(data?.amount) : 0;
    const available = isStringWithNumber(data?.cashBalance) ? Number(data?.cashBalance) : 0;

    if (total <= 0) {
      return 0;
    }

    const percent = (available / total) * 100;
    return Math.min(Math.max(percent, 0), 100);
  }, [data?.amount, data?.cashBalance]);

  return (
    <Box bg="white" borderRadius="16px" p="20px">
      <Text mt="4px" mb="14px">Доступно для перевода</Text>

      <HStack mb="10px" justifyContent="space-between">
        <Text mt="-4px" variant="brand" fontFamily="Normalidad Medium Var" fontSize="22px">
          {availableAmount}
        </Text>

        <Center w="86px" h="22px" bg="gray.50" justifyContent="center" borderRadius="35px">
          <Text fontSize="9px">Перевод по СБП</Text>
        </Center>
      </HStack>

      <Stack h="20px" mb="5px" justifyContent="center">
        <Progress
          h="2px"
          value={percentageLeft}
          colorScheme="purple"
          overflow="visible"
          sx={{
            "& > div": {
              height: "8px",
              marginTop: "-3px",
              borderRadius: "35px",
            },
          }}
        />
      </Stack>

      <Text mb="2px" fontSize="12px" lineHeight="12px">{totalAmountText}</Text>
    </Box>
  );
};
